<template>
  <el-dialog
    v-loading="isLoading"
    title="合同附件"
    :visible.sync="isShow"
    width="800px"
    destroy-on-close
    @close="closeDoalog"
  >
    <el-table :data="tableData" border>
      <el-table-column prop="rfileName" label="文件名称" align="left">
        <template v-slot="{row}">
          <el-button type="text" style="margin-left: 10px" @click="previewFile(row)">
            {{ row.rFileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="rCreatedBy" label="上传人" align="left" />
      <el-table-column prop="rCreatedTime" label="上传时间" align="left" />
      <el-table-column label="操作" align="left" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" style="margin-left: 10px" @click="downloadContract(row)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer">
      <el-button type="default" @click="closeDoalog">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { agGetAttachment, getUrlByFileID, attachmentGetToken } from '@/API';
import { downloadUrlFile } from '@/libs/util';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      tableData: []
    };
  },

  methods: {
    openDialog (data) {
      this.isShow = true;
      this.isLoading = true;
      this.queryData(data);
    },

    closeDoalog () {
      this.tableData = [];
      this.isShow = false;
    },

    queryData ({ reContractId }) {
      agGetAttachment({ contractId: reContractId, fileType: 1 })
        .then(res => {
          this.isLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.tableData = data;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    previewFile ({ rFileCode }) {
      getUrlByFileID(rFileCode).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          window.open(data);
        }
      });
    },

    downloadContract ({ rFileCode }) {
      attachmentGetToken().then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          downloadUrlFile(`${data.downloadUrl}/${rFileCode}?Token=${data.token}`);
        }
      });
    }
  }
};
</script>
